'use strict';

// GTM-KILL
/* Google Analytics Tracking */
(function ($, window, document)
{
    window.gaTrackEvent = function (eventCategory, eventAction, eventLabel, eventValue)
    {
        eventAction = eventAction || ''; // default to empty string
        eventLabel = eventLabel || '';
        eventValue = eventValue || '';
        window.dataLayer.push
        ({
            'event': 'GAEvent',
            'eventCategory': eventCategory,
            'eventAction': eventAction,
            'eventLabel': eventLabel,
            'eventValue': eventValue
        });
    };

    window.gaTrackView = function (eventVirtualPath)
    {
        // do not track in edit-mode
        if (App.Variable('editMode')) return;
        window.dataLayer.push
        ({
            'event': 'GAView',
            'eventVirtualPath': eventVirtualPath
        });
    };

    $(document).on('click', 'button[data-track]', function(event)
    {
        var $target = $(event.target);
        var $form = $target.closest('form');
        var eventCategory = $target.data('track');
        var eventAction = '';
        var eventLabel = '';
        var eventValue = '';
        if (eventCategory === 'Offerbutton')
        {
            // Offerbutton:
            eventAction = 'Submit';
            eventLabel = $form.find('input[name="offer_identifier"]').val();
            eventValue = $form.find('input[name="amount"]').val();
        } else throw 'Unknown data-track';

        // track the event, and 200ms later submit the form
        window.gaTrackEvent(eventCategory, eventAction, eventLabel, eventValue);
        window.setTimeout(function()
        {
            $form.submit();
        }, 100);
        event.preventDefault();
    });

    $(document).on('click', 'a[data-track]', function(event)
    {
        var $this = $(this);
        var eventCategory = $this.data('track');
        var eventAction = '';
        var eventLabel = '';
        var eventValue = '';
        if (eventCategory === 'ButtonJump')
        {
            eventAction = $this.text();
            if ($this.data('trackAction'))
            {
                eventAction = $this.data('trackAction');
            }
            eventLabel = document.location.pathname;
        }
        window.gaTrackEvent(eventCategory, eventAction, eventLabel, eventValue);
        window.setTimeout(function()
        {
            document.location.href = $this.attr('href');
        }, 100);
        event.preventDefault();
    });

}) ($, window, window.document);
// GTM-KILL
